<script>
  import dayjs from 'dayjs'
  import localizedFormat from 'dayjs/plugin/localizedFormat'
  import Card from '../../../components/card.svelte'
  import DataTable from '../../../components/data_table.svelte'
  import StateChip from '../../../components/badges/state_chip.svelte'
  import { SUBMISSION_STATE } from '../../../components/badges/chip_maps.js'

  dayjs.extend(localizedFormat)

  let { questSubmissions } = $props()

  const records = $derived(questSubmissions?.records ?? [])
  const totalCount = $derived(questSubmissions?.total_count ?? 0)
  const shown = $derived(questSubmissions?.shown ?? 25)

</script>

<Card title="Quest Submissions">
  {#snippet actions()}
    <span class="badge badge-ghost">{totalCount}</span>
  {/snippet}

  <DataTable items={records} emptyMessage="No quest submissions.">
    {#snippet header()}
      <tr>
        <th>Quest</th>
        <th>State</th>
        <th>Rejection</th>
        <th>Reviewed By</th>
        <th>Date</th>
      </tr>
    {/snippet}
    {#snippet row(submission)}
      <tr>
        <td>
          {#if submission.quest_template_url}
            <a href={submission.quest_template_url} class="link link-hover">{submission.quest_template_name}</a>
          {:else}
            {submission.quest_template_name || '—'}
          {/if}
        </td>
        <td><StateChip label={submission.state_label} tone={SUBMISSION_STATE[submission.state] || 'ghost'} /></td>
        <td>{submission.rejection_category_label || '—'}</td>
        <td>
          {#if submission.reviewed_by?.url}
            <a href={submission.reviewed_by.url} class="link link-hover">{submission.reviewed_by.name}</a>
          {:else}
            —
          {/if}
        </td>
        <td>{dayjs(submission.created_at).format('ll')}</td>
      </tr>
    {/snippet}
  </DataTable>

  {#if totalCount > shown}
    <p class="text-xs text-base-content/60 mt-2">Showing latest {shown} of {totalCount}.</p>
  {/if}
</Card>
